<template>
  <v-dialog v-model="edits.integrationModal" width="600" :persistent="true">
    <v-card>
      <v-card-title class="black">
        <h2 class="pl-2 text-uppercase font-weight-light">
          {{title}}
        </h2>
        <v-spacer/>
        <span class="caption mt-0 pt-0 text-xs-right" v-if="edits.song">For song:<br/>{{edits.song.t}}</span>
      </v-card-title>

      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-select
              :items="platforms"
              v-if="!loading"
              label="Platform *"
              v-model="formData.platform_id"
              item-text="name"
              item-value="id"
              color="secondary"
              :disabled="!!edits.integration || busy"/>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Remote Identifier"
              color="secondary"
              v-model="formData.remote_identifier"
              :disabled="busy"
              :hint="remoteIdentifierHint"/>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-progress-circular indeterminate v-if="busy"></v-progress-circular>
          <v-btn color="secondary" flat @click="close()" :disabled="busy">Close</v-btn>
          <v-btn color="secondary black--text" @click="submit()" :disabled="busy">Save External Link</v-btn>
        </div>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>

export default {
  name: 'integration-edit-modal',
  props: {
    edits: Object
  },
  data () {
    return {
      loading: false,
      busy: false,
      formData: {
        song_id: null,
        platform_id: null,
        remote_identifier: null
      }
    }
  },
  computed: {
    title () {
      if (this.edits.integration) {
        return `Edit External Link: ${this.platform.name}`
      }
      return `Create External Link`
    },
    platforms () {
      return this.$store.state.platforms.items
    },
    platform () {
      return this.platforms.find(p => { return p.id === this.formData.platform_id })
    },
    remoteIdentifierHint () {
      var platform = this.platform
      return platform ? platform.remote_identifier_hint : 'No platform selected.'
    }
  },
  methods: {
    refreshData () {
      var integration = this.edits.integration
      var song = this.edits.song
      if (integration) {
        this.formData.song_id = integration.song_id || (song && song.id)
        this.formData.platform_id = integration.platform_id
        this.formData.remote_identifier = integration.remote_identifier
      } else {
        this.resetData()
      }
    },
    resetData () {
      var song = this.edits.song
      this.formData.song_id = song && song.id
      this.formData.platform_id = null
      this.formData.remote_identifier = null
    },
    submit () {
      this.busy = true
      var promise
      var integration = this.edits.integration
      if (integration && integration.id) {
        promise = this.$api.integrations.update(integration.id, this.formData)
      } else {
        promise = this.$api.integrations.create(this.formData)
      }
      return promise
        .then(_ => {
          this.close()
          this.$router.go(0) // ugly refresh
          this.busy = false
        })
        .catch(error => {
          console.log(error)
          this.busy = false
        })
    },
    close () {
      this.edits.integrationModal = false
    }
  },
  watch: {
    'edits.integrationModal': function (val) {
      if (val === true) {
        this.refreshData()
      } else {
        this.edits.integration = null
        this.edits.song = null
        this.resetData()
      }
    }
  }
}
</script>
